import {useEffect} from 'react';

const useCampaignTitle = (campaign, labelKey, defaultMessage = 'Happy Wheel') => {
    useEffect(() => {
      document.title = campaign?.labels?.[labelKey] || defaultMessage;
      return () => document.title = 'Happy Wheel';
    }, [campaign]);
};

export default useCampaignTitle;